// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1PwZ2","title":"BackImages_title__3l8Q8","images":"BackImages_images__1AaKz"};